module.exports = __webpack_public_path__ + "img/facebook.e95ab2bc.jpg";